import apiClient from "../../../../services/apiClient";


const benefits_fixed_kg = [
  "5bfb996f0b7fb2059b8828c9",
  "5c16b5a22f8be751f04fce92",
 // "60e81561904ae40729056dc4"
];

const check_brothers = '';
const ceck_emploers = '';
const check_territory = '';


async function Validate(FormData, isEdit){


    const errors = {};

    const {benefits} = FormData;

    const {kindergarten, type} = benefits;

    if(benefits_fixed_kg.includes(type)){
        const isLegal = true && kindergarten; //await apiClient.post('requests/checkSameCertNumber',{benefits});
        if(isLegal){
            FormData.selectedSchools=[kindergarten];
        } else {
            errors['type'] = "Пільга не підтверджена. В обраному садочку за вказаними параметрами інформація відсутня.";
        }
    }

    return errors;

}

export default Validate;